<ul nz-menu [nzInlineCollapsed]="isCollapsed()" [nzMode]="mode()">
  @for (item of menuItems(); track item.label; let idx = $index;) {
    @if(!item?.items) {
      <li
        (click)="handleSelect()"
        [attr.nz-submenu]="true"
        [routerLink]="item?.link"
        [routerLinkActive]="'ant-menu-item-selected'"
        nz-tooltip
        [nzTooltipTitle]="isCollapsed() ? item.label : null"
        [nzTooltipPlacement]="'right'"
        class="nav-menu-item"
        [ngClass]="{'open': !isCollapsed(), 'close': isCollapsed()}"
      >
        @if(item?.icon) {
          <ui-icon class="nav-menu-item__icon" nz-icon [icon]="item.icon" />
        }
        <span class="nav-menu-item__text">{{ item.label }}</span>
      </li>
    } @if(item?.items) {
      <li>
        <div class="flex align-middle" nz-dropdown [nzDropdownMenu]="menu" nzPlacement="topLeft">
          <nz-avatar class="my-3 mx-auto" nzIcon="user" [nzSrc]="(user$ | async)?.['picture']"></nz-avatar>
          @if(!isCollapsed()) {
            <p class="my-auto pr-3">{{(user$ | async)?.['name']}}</p>
          }
        </div>
        <nz-dropdown-menu #menu>
          <ul nz-menu class="menu">
            @for (subitem of item.items; track subitem.label; let idx = $index;) {
            <li
              nz-menu-item
              [routerLink]="subitem?.link"
              [routerLinkActive]="'ant-menu-item-selected'"
              (click)="handleSelect(subitem?.action)"
            >
              @if(subitem?.icon) {
                <ui-icon nz-icon [icon]="subitem.icon" />
              }
              <span class="nav-menu-item__text ml-3">{{ subitem.label }}</span>
            </li>
            }
          </ul>
        </nz-dropdown-menu>
      </li>
    }
  }
</ul>
